module.exports = __webpack_public_path__ + "assets/img/prd3-12.b68850b0.jpg";